import { memo, forwardRef } from 'react';
import { Icon } from '../icon/index.js';
import { IconButtonBase, IconMouseClickFocusRemover } from './styles/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const IconButton = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    svgIcon,
    transform,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs(IconButtonBase, {
    ...props,
    ref: ref,
    children: [/*#__PURE__*/jsx(Icon, {
      svgIcon: svgIcon,
      transform: transform,
      block: true
    }), /*#__PURE__*/jsx(IconMouseClickFocusRemover, {})]
  });
}));

export { IconButton };
//# sourceMappingURL=index.js.map
